module.exports = __webpack_public_path__ + "img/Daily-Downloads-of-Selected-Packages-1-1024x878.f4b07387.png";